import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Chip } from "@mui/material";
import MainApi from "../../../../../../services/mainApi.service";
import { useCallback, useMemo, useState } from "react";
import { ITicketAutRecRuleTasyOrientation } from "../../../../../../models/ticket-aut-rec-rule-tasy-orientation";
import { Table } from "@4uhub/lib4uhub";
import TicketAutRecRuleTasyOrientation from "./TicketAutRecRuleTasyOrientationForm/TicketAutRecRuleTasyOrientation";

const TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutRecRuleTasyOrientation/";
const ticketAutRecRuleTasyOrientationService =
  new MainApi<ITicketAutRecRuleTasyOrientation>(
    TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE,
  );

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleTasyOrientation.";

const TicketAutRecRuleTasyOrientationPage = ({
  automationCode,
}: {
  automationCode?: string;
}) => {
  const { t } = useTranslation();

  const { id: ticketAutomationReceivedRuleId } = useParams();

  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<ITicketAutRecRuleTasyOrientation>[] = [
    {
      field: "sendWhen",
      headerName: t(translationPath + "send_when") || "Send When",
      renderCell: (params) =>
        params.row.sendWhen ? params.row.sendWhen.name : "-",
    },
    {
      field: "typeTasyOrientation",
      headerName:
        t(translationPath + "type_tasy_orientation") || "Type Tasy Orientation",
      renderCell: (params) =>
        params.row.typeTasyOrientation
          ? params.row.typeTasyOrientation.name
          : "-",
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 120,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<ITicketAutRecRuleTasyOrientation>,
  ) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);
  const props = useMemo(() => {
    return {
      TicketAutomationReceivedRuleId: ticketAutomationReceivedRuleId,
    };
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <TicketAutRecRuleTasyOrientation
            id={selectedId}
            ticketAutomationReceivedRuleId={ticketAutomationReceivedRuleId}
            onBackButton={handleBack}
            automationCode={automationCode}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<ITicketAutRecRuleTasyOrientation>
            showDefaultMacroFilters={false}
            service={ticketAutRecRuleTasyOrientationService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add_ticket_autrecrule_tasy_orientation") ||
              "Add Tasy Orientation"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default TicketAutRecRuleTasyOrientationPage;
